/* PULSE FULL-SCREEN VIDEO VIEWER -----------------------------------------------
   Lifted out of sections/pulse-dance-extras.liquid on 2026-09-13 so the homepage
   tiles and the dance-style collections share ONE viewer.

     window.PulseVideoViewer.open(items, index)
     window.PulseVideoViewer.close()

   An item is { mp4, poster, label, href, who }:
     mp4     the clip
     poster  optional, painted before the first frame decodes
     label   the style name, rendered as a link when href is set
     href    optional destination for the label
     who     the credit; rendered as @handle under the clip

   The markup ships in snippets/pulse-video-viewer.liquid. Two sections on one page
   render it twice, so THIS script is the de-dupe: it keeps the FIRST [data-dvlight],
   drops the rest, and moves the survivor to <body> -- the sections' wrappers form
   stacking contexts and the fixed header painted over the close button on a phone
   (measured 2026-09-09).

   Classic script, no modules, no dependencies.
   ---------------------------------------------------------------------------- */
(function () {
  /* two sections on one page each emit this <script src>, so the IIFE runs twice.
     A second run must be a total no-op: otherwise instance B overwrites
     window.PulseVideoViewer with its own {open, close}, while bind() (guarded by
     data-dvlight-bound) never rewires the close/prev/next/keys/swipe listeners to
     it, leaving them stuck on instance A's never-opened, empty `items`. */
  if (window.PulseVideoViewer) return;

  var light = null, vid = null, who = null, label = null, stage = null,
      bPrev = null, bNext = null, bClose = null;
  var items = [], idx = -1, lastFocus = null, keysBound = false;

  /* one viewer per page: everything that is not the one we kept goes */
  function dedupe(keep) {
    var all = [].slice.call(document.querySelectorAll('[data-dvlight]'));
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== keep && all[i].parentNode) all[i].parentNode.removeChild(all[i]);
    }
  }

  function mount() {
    var first = document.querySelector('[data-dvlight]');
    if (!first) return null;
    dedupe(first);
    if (first.parentNode !== document.body) document.body.appendChild(first);
    return first;
  }

  function init() {
    if (light && light.parentNode) { dedupe(light); return true; }
    light = mount();
    if (!light) return false;
    vid    = light.querySelector('[data-dvlight-video]');
    who    = light.querySelector('[data-dvlight-who]');
    label  = light.querySelector('[data-dvlight-label]');
    stage  = light.querySelector('[data-dvlight-stage]');
    bPrev  = light.querySelector('[data-dvlight-prev]');
    bNext  = light.querySelector('[data-dvlight-next]');
    bClose = light.querySelector('[data-dvlight-close]');
    if (!vid || !stage || !bPrev || !bNext || !bClose) { light = null; return false; }
    bind();
    return true;
  }

  function show(i) {
    if (!light || i < 0 || i >= items.length) return;
    idx = i;
    var it = items[i] || {};
    vid.pause();
    if (it.poster) vid.setAttribute('poster', it.poster); else vid.removeAttribute('poster');
    vid.src = it.mp4 || '';
    vid.muted = false;
    /* the handle is stored bare and printed with the @; a caller that already
       carries one must not end up with two */
    var h = it.who ? String(it.who) : '';
    if (who) who.textContent = h ? (h.charAt(0) === '@' ? h : '@' + h) : '';
    if (label) {
      label.textContent = it.label ? String(it.label) : '';
      if (it.label && it.href) label.setAttribute('href', it.href);
      else label.removeAttribute('href');
    }
    bPrev.disabled = (i === 0);
    bNext.disabled = (i === items.length - 1);
    var p = vid.play(); if (p && p.catch) p.catch(function () { vid.muted = true; vid.play(); });
  }

  function open(list, i) {
    if (!init()) return;
    if (list && list.length) items = [].slice.call(list);
    if (!items.length) return;
    lastFocus = document.activeElement;
    light.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    show(i > 0 ? i : 0);
    bClose.focus();
  }

  function close() {
    if (!light) return;
    vid.pause(); vid.removeAttribute('src'); vid.load();
    light.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    /* tells any caller that paused its own clips behind the dialog (e.g. the
       pulse-folders tile grid) that it is safe to resume them */
    document.dispatchEvent(new CustomEvent('pulse:video-viewer-close'));
  }

  function bind() {
    if (light.getAttribute('data-dvlight-bound')) return;
    light.setAttribute('data-dvlight-bound', '1');

    bClose.addEventListener('click', close);
    bPrev.addEventListener('click', function () { show(idx - 1); });
    bNext.addEventListener('click', function () { show(idx + 1); });
    vid.addEventListener('click', function () { if (vid.paused) vid.play(); else vid.pause(); });

    if (!keysBound) {
      keysBound = true;
      document.addEventListener('keydown', function (e) {
        if (!light || light.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(idx + 1);
        else if (e.key === 'ArrowLeft') show(idx - 1);
      });
    }

    // swipe: a horizontal drag of 40px or more moves a clip; a tap on the black closes
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; tracking = true; });
    stage.addEventListener('pointerup', function (e) {
      if (!tracking) return; tracking = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) show(idx + 1); else show(idx - 1); }
      else if (Math.abs(dx) < 6 && Math.abs(dy) < 6 && e.target === stage) close();
    });
    stage.addEventListener('pointercancel', function () { tracking = false; });
  }

  /* THE DANCE-STYLE RAIL, unchanged: every [data-dvcard] button on the page is one
     item, in document order, and a click opens the viewer at that card. */
  function wireCards() {
    var cards = [].slice.call(document.querySelectorAll('[data-dvcard]'));
    if (!cards.length) return;
    var list = cards.map(function (c) {
      return {
        mp4: c.getAttribute('data-mp4'),
        poster: '',
        label: '',
        href: '',
        who: c.getAttribute('data-who')
      };
    });
    cards.forEach(function (c, i) {
      if (c.getAttribute('data-dvcard-bound')) return;
      c.setAttribute('data-dvcard-bound', '1');
      c.addEventListener('click', function () { open(list, i); });
    });
  }

  function start() { init(); wireCards(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // the theme editor re-renders a section without reloading the page
  document.addEventListener('shopify:section:load', start);

  window.PulseVideoViewer = { open: open, close: close };
})();
